import { schema } from 'normalizr';
import schemaTree, { type SchemaTreeEntry } from './schemaTree';

const options = {
  idAttribute: (value: any) => value.meta.id,
};

interface SchemasMap {
  [key: string]: any;
  generateGenericSchema: (name: string) => void;
  getSchema: (type: string) => schema.Entity;
  getSchemaTree: (type: string) => SchemaTreeEntry;
}

const schemas = {} as SchemasMap;

Object.keys(schemaTree).forEach((key) => {
  const definition: Record<string, any> = {};
  if (!schemaTree[key].name) {
    schemaTree[key].name = key;
  }
  schemaTree[key].dependencies.forEach((dep) => {
    definition[dep.key] = dep.type === 'many' ? [schemas[dep.key]] : schemas[dep.key];
  });
  schemas[key] = new schema.Entity(schemaTree[key].name as string, definition, options);
});

schemas.generateGenericSchema = (name: string) => {
  schemaTree[name] = {
    name,
    dependencies: [],
  };
  schemas[name] = new schema.Entity(name, {}, options);
};

schemas.getSchema = (type: string) => {
  if (!Object.prototype.hasOwnProperty.call(schemas, type)) {
    schemas.generateGenericSchema(type);
  }
  return schemas[type];
};

schemas.getSchemaTree = (type: string) => {
  if (!Object.prototype.hasOwnProperty.call(schemas, type)) {
    schemas.generateGenericSchema(type);
  }
  return schemaTree[type];
};

export default schemas;
